import ko from 'knockout';

export default class ViewModel {
  constructor() {
    this.isDynamicAdGroupSectionExpanded = ko.observable(true);
    this.isStandardAdGroupSectionExpanded = ko.observable(true);
    this.hasDSASettings = ko.observable(false);
    this.hasDisclaimerSettings  = ko.observable(false);
    this.isDomesticSimplifiedChineseEnabled  = ko.observable(false);
    this.errors = ko.observable([]);
    this.allowDisclaimer = ko.observable(false);
  }
}
